var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

var TableRow = function TableRow(props) {
  var even = props.even,
      header = props.header,
      className = props.className,
      children = props.children,
      other = _objectWithoutProperties(props, ['even', 'header', 'className', 'children']);

  var tableRowClasses = classNames(className, 'bx--table-row', {
    'bx--parent-row': !header,
    'bx--parent-row--even': even
  });

  return React.createElement(
    'tr',
    _extends({}, other, { className: tableRowClasses }),
    children
  );
};

TableRow.propTypes = {
  header: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  even: PropTypes.bool
};

TableRow.defaultProps = {
  header: false
};

export default TableRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/TableRow/TableRow.js
// module id = 374
// module chunks = 0